import { MODULES, ACTIONS, buildEmptyPermissions, buildFullPermissions } from 'constants/permissions';
import { ENTITY_STATUS } from 'constants/status';
import { SEED_ROLE_NAMES } from 'constants/roles';

/** Helper to set specific module/action flags on top of an empty matrix. */
const withPerms = (config) => {
  const perms = buildEmptyPermissions();
  Object.entries(config).forEach(([module, actions]) => {
    actions.forEach((action) => {
      if (perms[module]) perms[module][action] = true;
    });
  });
  return perms;
};

export const MOCK_ROLES = [
  {
    id: 'role-admin',
    role_name: SEED_ROLE_NAMES.ADMIN,
    description: 'Full system access.',
    permissions: buildFullPermissions(),
    allowed_newspapers: ['ALL'],
    status: ENTITY_STATUS.ACTIVE,
    is_system: true,
    created_at: '2026-01-01T00:00:00Z',
  },
  {
    id: 'role-reviewer',
    role_name: SEED_ROLE_NAMES.REVIEWER,
    description: 'Reviews the feed and routes articles.',
    permissions: withPerms({
      [MODULES.DASHBOARD]: [ACTIONS.VIEW],
      [MODULES.STAGE1]: [ACTIONS.VIEW, ACTIONS.REJECT],
      [MODULES.STAGE2]: [ACTIONS.VIEW, ACTIONS.ROUTE],
    }),
    allowed_newspapers: ['ALL'],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-05T00:00:00Z',
  },
  {
    id: 'role-storage',
    role_name: SEED_ROLE_NAMES.STORAGE_MANAGER,
    description: 'Manages storage destinations and dispatch.',
    permissions: withPerms({
      [MODULES.DASHBOARD]: [ACTIONS.VIEW],
      [MODULES.STORAGE1]: [ACTIONS.VIEW, ACTIONS.DISPATCH],
      [MODULES.STORAGE2]: [ACTIONS.VIEW],
    }),
    allowed_newspapers: ['ALL'],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-06T00:00:00Z',
  },
  {
    id: 'role-dataentry',
    role_name: SEED_ROLE_NAMES.DATA_ENTRY,
    description: 'Ingests newspapers via manual upload.',
    permissions: withPerms({
      [MODULES.DASHBOARD]: [ACTIONS.VIEW],
      [MODULES.STAGE1]: [ACTIONS.VIEW, ACTIONS.CREATE, ACTIONS.EDIT, ACTIONS.MANUAL_UPLOAD],
    }),
    allowed_newspapers: ['Dainik Bhaskar'],
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-07T00:00:00Z',
  },
  {
    id: 'role-supervisor',
    role_name: SEED_ROLE_NAMES.SUPERVISOR,
    description: 'Oversees Stage 1 and Stage 2.',
    permissions: withPerms({
      [MODULES.DASHBOARD]: [ACTIONS.VIEW],
      [MODULES.STAGE1]: [ACTIONS.VIEW, ACTIONS.REJECT],
      [MODULES.STAGE2]: [ACTIONS.VIEW, ACTIONS.ROUTE],
    }),
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-08T00:00:00Z',
  },
];

export default MOCK_ROLES;
